import { Component, AfterViewInit, HostListener, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IContextService, CoreConstants, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PortalComponentService } from '../services/portal-component.service';
import { Router } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';

@Component({
    selector: 'f2-common',
    templateUrl: './f2.common.html'
})
export class NxiF2Common implements AfterViewInit {

    theme: string = 'netxinvestor-conservative';
    locale: string = 'en-us';
    alertsSigned: boolean = false;
    subs: Subscription;
    acctRef: any;
    serviceUrl: string;
    refreshArgs: any;
    currentUrl: string;
    appsType: string;
    modF2Domain: string;
    keyData: string;
    signedToken: string;
    defaultApps = ['com_pershing_netx_markets_symbolsearch_', 'com_pershing_netx_shared_pagesettings_large'];
    disableRT = ['eventscalendar'];
    disableStreaming = ['usmarkets', 'eventscalendar'];
    disableHelp = ['mywatchlists'];
    /*
    * For few scenarios, apps in parent route needs to be re-rendered to show its updated
    * state. Eg: While searching a symbol in symbol search, the recent search should be
    * updated with latest symbol. Similary, quotebar should be updated for the current symbol
    * Add the appid unique identifiers to this list based on the event/url to get the apps re-rendered
    */
    reRenderParentViewComps = { 'defaultapps': ['pagesettings'], 'apps': [] };

    constructor(
        @Optional() @Inject('AppSettings') private appSettings: any,
        private http: HttpClient,
        private contextService: IContextService,
        private router: Router,
        private portalService: PortalComponentService) {
        this.serviceUrl = this.portalService.serviceUrl;
        this.modF2Domain = appSettings.modF2Domain;
        if (appSettings.themeType) {
            this.theme = appSettings.themeType;
        }
        if (appSettings.locale) {
            this.locale = appSettings.locale;
        }
        if (appSettings.deviceType === 'desktop') {
            this.appsType = 'large';
        } else if (appSettings.deviceType === 'mobile') {
            this.appsType = 'small';
        } else if (appSettings.deviceType === 'tablet') {
            this.appsType = 'large';
        }
    }

    getAlertsSigned() {
        if ((<any>window).NXIF2Container.alertsSigned !== true) {
            this.http.get(this.serviceUrl + '/portfolio/market/alerts-agreement',
                { responseType: 'json' }).subscribe((data: any) => {
                    if (data === true) {
                        this.alertsSigned = true;
                    } else {
                        if ((document.cookie.split(';').filter(function (item) { return item.trim().indexOf('AlertsSigned=') === 0; }).length) > 0) {
                            this.alertsSigned = true;
                        } else {
                            this.alertsSigned = false;
                        }
                    }
                    (<any>window).NXIF2Container.alertsSigned = this.alertsSigned;
                });
            return this.alertsSigned;
        }
    }

    getUnSignedValue() {
        this.http.get(this.serviceUrl + '/portfolio/modUnsignedValue',
            { responseType: 'json' }).subscribe((data: any) => {
                if (data) {
                    this.keyData = data;
                    // (<any>window).NXIF2Container.keyData = data;
                } else {
                    this.keyData = '';
                    // (<any>window).NXIF2Container.keyData = '';
                }
                this.getSignedValue();
            });
    }

    getSignedValue() {
        this.http.get(this.serviceUrl + '/portfolio/modSignedValue',
            { responseType: 'json' }).subscribe((data: any) => {
                if (data) {
                    this.signedToken = data;
                    // (<any>window).NXIF2Container.signedToken = data;
                } else {
                    this.signedToken = '';
                    // (<any>window).NXIF2Container.signedToken = '';
                }
                this.findAndRegisterApps(false);
            });
    }

    modValues() {
        this.http.get(this.serviceUrl + '/portfolio/modPassValue',
        { responseType: 'json' }).subscribe((data: any) => {
            if (data) {
                this.signedToken = data.signedToken;
                this.keyData = data.keyData;
                // (<any>window).NXIF2Container.signedToken = data;
            } else {
                this.signedToken = '';
                this.keyData = '';
                // (<any>window).NXIF2Container.signedToken = '';
            }
            this.findAndRegisterApps(false);
        });
    }

    getMODAccessed() {
        if ((<any>window).NXIF2Container.modAccessed !== true) {
            this.http.get(this.serviceUrl + '/mod/accessed',
                { responseType: 'json' }).subscribe((data: any) => {
                    (<any>window).NXIF2Container.modAccessed = true;
                });
        }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            // this.domain = domainContext.domain ? domainContext.domain : CoreConstants.ACCOUNT;
            if (domainContext.domain === CoreConstants.ACCOUNT) {
                let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
                this.acctRef = contextValue.hashValue;
                (<any>window).NXIF2Container.acctRef = this.acctRef;
            }
        });
        this.currentUrl = this.router.url;
        const classes: string = document.body.getAttribute('class');
        if (this.currentUrl.indexOf('/tools') > -1) {
            this.defaultApps = [];
            this.addComponentsToReRenderList([]);
            this.updateClass(classes, '');
        } else if (this.currentUrl.indexOf('/stocks/') > -1) {
            this.defaultApps.push('com_pershing_netx_quotesnews_stocksquotebar_');
            this.addComponentsToReRenderList(['quotebar', 'symbolsearch']);
            this.updateClass(classes, '');
        } else if (this.currentUrl.indexOf('/etf/') > -1) {
            this.defaultApps.push('com_pershing_netx_quotesnews_etfsquotebar_');
            this.addComponentsToReRenderList(['quotebar', 'symbolsearch']);
            if (this.currentUrl.indexOf('etperformance') > -1 || this.currentUrl.indexOf('etfsummary') > -1) {
                this.updateClass(classes, 'etf-summary');
            } else {
                this.updateClass(classes, '');
            }
        } else if (this.currentUrl.indexOf('/mutualfunds/') > -1) {
            this.defaultApps.push('com_pershing_netx_quotesnews_mfsquotebar_');
            this.addComponentsToReRenderList(['quotebar', 'symbolsearch']);
            if (this.currentUrl.indexOf('mfperformance') > -1 || this.currentUrl.indexOf('mfsummary') > -1) {
                this.updateClass(classes, 'mf-summary');
            } else {
                this.updateClass(classes, '');
            }
        } else {
            this.addComponentsToReRenderList([]);
            this.updateClass(classes, '');
        }

        (<any>window).NXIF2Container.orderProspectusUrl = 'https://prospectus-express.broadridge.com/get_template.asp';
    }

    updateClass(classes: string, className: string) {
        if (classes && classes.length > 0) {
            const classList: string[] = classes.split(' ');
            let updatedClassList = classList.filter((c: string) => !(c.length <= 0));
            updatedClassList = updatedClassList.filter((c: string) => !c.startsWith('mf'));
            const finalClassList = updatedClassList.filter((c: string) => !c.startsWith('etf'));
            finalClassList.push(className);
            document.body.setAttribute('class', finalClassList.join(' '));
        }
    }
    addComponentsToReRenderList(apps: string[]) {
        let reRenderCompsList: any = [];
        reRenderCompsList = this.reRenderParentViewComps.defaultapps.concat(apps);
        this.reRenderParentViewComps.apps = reRenderCompsList;
    }

    findAndRegisterApps(isSameViewRendering: boolean) {
        (<any>window).invokeModOda(); // invoking MOD ODA call
        let appConfigs = [];
        let appConfig = this.makeAppConfig(isSameViewRendering);
        if (!appConfigs[0]) {
            appConfigs[0] = [];
        }
        appConfigs[0].push(appConfig);

        if (appConfigs.length === 0) { return false; }

        for (let index = 0; index < appConfigs.length; ++index) {
            this.registerF2Apps(appConfigs[index]);
        }
    }
    ngAfterViewInit() {
        this.getAlertsSigned();
        // this.getSignedValue();
        // this.getUnSignedValue();
        this.modValues();
        this.getMODAccessed();
    }
    @HostListener('document:portal.refreshmodview', ['$event'])
    renderSameModView(event: any) {
        // undefined check for IE 11
        if (event.detail !== null && event.detail !== undefined) {
            this.refreshArgs = event.detail.refreshParams;
        }
        this.findAndRegisterApps(true);
    }
    registerF2Apps(appConfig: object): void {
        (<any>window).NXIF2Container.callRegisterF2Apps(appConfig, this.keyData, this.signedToken);
    }

    makeAppConfig(isSameViewRendering: boolean): object[] {
        let apps = document.querySelectorAll('div.f2-app');
        let loadedApps = [];
        let appConfig = [];
        for (let x = 0; x < apps.length; x++) {
            let curApp = <HTMLElement>apps[x];
            let ctx = this.getQueryParams(curApp.offsetWidth);

            if (curApp.getAttribute('id').indexOf('shared_pagesettings') > -1) {
                ctx['disableRT'] = (this.checkDisableValue(this.disableRT) ? true : false);
                ctx['disableHelp'] = (this.checkDisableValue(this.disableHelp) ? true : false);
                ctx['disableStreaming'] = (this.checkDisableValue(this.disableStreaming) ? true : false);
            }
            if (isSameViewRendering || this.reRenderApp(curApp.getAttribute('id')).length > 0) {
                if (curApp.childNodes.length > 0) {
                    for (let i = curApp.childNodes.length - 1; i >= 0; i--) {
                        curApp.removeChild(curApp.childNodes[i]);
                    }
                }
            }
            if (curApp.childNodes.length > 0) {
                loadedApps.push(curApp.getAttribute('id'));
            } else {
                let app = {};
                app['appId'] = curApp.getAttribute('id');
                app['manifestUrl'] = this.modF2Domain + '/f2api/apps/json';
                app['context'] = ctx;
                app['enableBatchRequests'] = true;
                appConfig.push(app);
            }
        }
        if (!(loadedApps.length > 0) && !(this.theme === 'ada')) {
            for (let x = 0; x < this.defaultApps.length; x++) {
                console.log('defaultApps' + this.defaultApps[x]);
                let appsCheck;
                if (!(this.defaultApps[x].indexOf('pagesettings') > -1)) {
                    appsCheck = this.defaultApps[x] + this.appsType;
                } else {
                    appsCheck = this.defaultApps[x];
                }
                if (!(this.availableInAppConfig(appConfig, appsCheck))) {
                    let app = {};
                    let ctx = this.getQueryParams('1180');
                    app['appId'] = appsCheck;
                    app['manifestUrl'] = this.modF2Domain + '/f2api/apps/json';
                    app['context'] = ctx;
                    app['enableBatchRequests'] = true;
                    appConfig.push(app);
                }
            }
        }
        return appConfig;
    }
    checkDisableValue(disableValue: string[]) {
        for (let x = 0; x < disableValue.length; x++) {
            if (this.currentUrl.indexOf(disableValue[x]) > -1) {
                return true;
            }
        }
        return false;
    }

    reRenderApp(appId: string): any[] {
        let res = this.reRenderParentViewComps['apps'].filter(key => appId.includes(key));
        return res;
    }

    availableInAppConfig(appConfig, checkAppId): boolean {
        let value: boolean = false;
        for (let i = 0; i < appConfig.length; i++) {
            if (appConfig[i].appId === checkAppId) {
                console.log('available in Appconfig:: ' + checkAppId);
                value = true;
                break;
            }
        }
        return value;
    }

    getQueryParams(appWidth): object {
        let f2Theme = 'NULL';
        let language = 'NULL';
        // setting theme
        if (this.theme === 'standard') {
            f2Theme = 'conservative';
        } else if (this.theme === 'ada') {
            f2Theme = 'ada';
        }
        else if (this.theme === 'modern') {
            f2Theme = 'conservative';
        }

        // setting language
        if (this.locale) {
            language = this.locale.toLowerCase();
        } else {
            language = 'en-us';
        }
        let ctx = { 'containerWidth': appWidth, 'theme': f2Theme, 'lang': language };
        if (location.search != null) {
            let aQueryString = location.search.substring(1).split('&');
            for (let i = 0; i < aQueryString.length; i++) {
                let aTemp = aQueryString[i].split('=');
                let key = aTemp[0];
                let val = aTemp[1];
                if (val && val.length > 0) {
                    // Below is added to support parsing MOD's screener parameters
                    if (key && (key === 'ExtraCriteria' || key === 'Parameters')) {
                        val = JSON.parse(decodeURIComponent(val));
                        ctx[key] = val;
                    } else {
                        ctx[key] = decodeURIComponent(val);
                    }
                }
            }
        }
        if (this.acctRef) {
            ctx['account'] = this.acctRef;
        }
        if (this.refreshArgs) {
            for (let key in this.refreshArgs) {
                if (this.refreshArgs.hasOwnProperty(key)) {
                    ctx[key] = this.refreshArgs[key];
                }
            }
        }
        // console.log('context', ctx);
        return ctx;
    }
}
